import React from "react";
import { Skeleton } from "@mui/material";
const InputSkeleton: React.FC = () => {
  return (
    <div className="skeleton-container">
      <Skeleton
        animation="wave"
        sx={{
          height: "100%",
        }}
      />
    </div>
  );
};

export default InputSkeleton